// v2/hooks/useYeniSiparis.js — yonetim: yeni siparis yoklamasi
// Uc: GET /api/v2/admin/orders/new/ (v2_admin_bildirim.py; birincil anahtar uzerinden, hafif)
//  - Ilk cagri baslangic noktasini alir (eski siparisler bildirilmez)
//  - 20 sn'de bir sorar; sekmeye donulunce hemen sorar; ust uste istek atmaz
//  - Birden fazla sekme acikken ayni siparis icin ses yalnizca BIR sekmede calar
import { useEffect, useRef } from 'react';
import { apiGet } from '../utils/api';

const ARALIK_MS = 20000;
const PAYLASIM_KEY = 'v2_yeni_siparis_son';

export default function useYeniSiparis(aktif, onYeni) {
  const sonId = useRef(null);
  const geriCagri = useRef(onYeni);

  useEffect(() => { geriCagri.current = onYeni; }, [onYeni]);

  useEffect(() => {
    if (!aktif) return undefined;
    let iptal = false;
    let zamanlayici = null;
    let calisiyor = false;

    const yokla = async () => {
      if (calisiyor || iptal) return;
      calisiyor = true;
      try {
        const sorgu = sonId.current === null ? '' : `?after=${sonId.current}`;
        const v = await apiGet(`/v2/admin/orders/new/${sorgu}`);
        if (iptal || !v || !v.success) return;
        const yeniSon = Number(v.last_id) || 0;
        const ilkCagri = sonId.current === null;
        sonId.current = yeniSon;
        if (!ilkCagri && Array.isArray(v.items) && v.items.length) {
          let sesCal = true;
          try {
            const paylasilan = Number(window.localStorage.getItem(PAYLASIM_KEY)) || 0;
            if (paylasilan >= yeniSon) sesCal = false;       // baska sekme caldi
            else window.localStorage.setItem(PAYLASIM_KEY, String(yeniSon));
          } catch (e) { /* localStorage kapali: yine de cal */ }
          geriCagri.current(v.items, sesCal);
        }
      } catch (e) {
        /* ag hatasi: bir sonraki turda tekrar denenir */
      } finally {
        calisiyor = false;
        if (!iptal) {
          clearTimeout(zamanlayici);
          zamanlayici = setTimeout(yokla, ARALIK_MS);
        }
      }
    };

    const gorunurOldu = () => {
      if (document.visibilityState === 'visible') {
        clearTimeout(zamanlayici);
        yokla();
      }
    };

    yokla();
    document.addEventListener('visibilitychange', gorunurOldu);
    return () => {
      iptal = true;
      clearTimeout(zamanlayici);
      document.removeEventListener('visibilitychange', gorunurOldu);
    };
  }, [aktif]);
}
